import ChangePasswordDialog from "views/viewport/ChangePasswordDialog";

export default function SetPassword() {
  return (
    <>
      <ChangePasswordDialog />
    </>
  );
}
